<template>
  <div>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>

    <!--   Main Content Start Here   -->
    <main>
      <section class="dashboard_wraper">
        <div class="container_large">
          <div class="row">
            <!-- starting side bar -->
            <sidebar-component></sidebar-component>
            <!-- ending sidebar  -->
            <div class="col-md-12 col-lg-9">
              <div class="dashboard_card">
                <div class="row">
                  <div class="col-6">
                    <h2>Payment Methods</h2>
                  </div>
                   <div class="col-6 text-right">
                    <router-link :to="{name:'add-wallet'}">
                    <button
                      type="button"
                      class="button primary_button"
                      aria-label="Close"
                    >
                      Add new Credit Card
                    </button>
                    </router-link>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Customer id</th>
                        <th scope="col">Type</th>
                        <th scope="col">last four</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody v-if="payments_methods && payments_methods.length">
                      <!-- Leave First Row Empty -->
                      <tr>
                        <td colspan="6"></td>
                      </tr>

                      <!-- Loop Start Here -->
                      <tr v-for="data in payments_methods" :key="data">
                        <td>{{ data.id }}</td>
                        <td>{{ data.customer }}</td>
                        <td>{{ data.type }}</td>
                        <td>
                          {{
                            data.card && data.card.last4 ? data.card.last4 : ""
                          }}
                        </td>
                        <td>
                          <a class="pointer" @click="deleteModal(data.id)"
                            ><img src="/src/assets/images/del-icon.svg" alt=""
                          /></a>
                        </td>
                      </tr>
                    </tbody>

                    <tbody v-if="!payments_methods || !payments_methods.length">
                      <!-- Leave First Row Empty -->
                      <tr>
                        <td colspan="6"></td>
                      </tr>

                      <!-- Loop Start Here -->
                      <tr>
                        You don't have added any card yet
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <!--   Main Content End Here   -->

    <!-- Delete Modal -->
    <div
      class="modal fade"
      id="delete_order"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="close_modal">
              <button type="button" data-bs-dismiss="modal" aria-label="Close">
                <i class="fi fi-rr-cross-small"></i>
              </button>
            </div>
            <div class="modal_content">
              <h2>Delete card</h2>
              <p>Are you sure want to delete this item?</p>
              <div class="modal_buttons">
                <button
                  type="button"
                  class="button secondary_button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  No
                </button>
                <button
                  type="button"
                  class="button primary_button"
                  @click.prevent="deleteWallet()"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import usersApis from "../../Apis/users";
import { getCurrentUserId } from "../../utils/auth";

import sidebarComponent from "./sidebar";

export default {
  components: {
    sidebarComponent,
  },
  data() {
    return {
      payments_methods: null,
      deleted_id: null,
      loader: true,
    };
  },
  methods: {
    async getPayments() {
      const uid = getCurrentUserId();

      const response = (await usersApis.getWallets(uid)).data;
      if (response) {
        this.payments_methods = response.data ? response.data : "";
      }
      this.loader = false;
    },
    deleteModal(id) {
      this.deleted_id = id;

      var myModal = new bootstrap.Modal(
        document.getElementById("delete_order")
      );
      myModal.show();
    },
    async deleteWallet() {
      console.log("dddd");
      this.loader = true;

      await usersApis.deleteWallet(this.deleted_id);

      this.deleted_id = null;
      this.getPayments();
      var myModal = new bootstrap.Modal(
        document.getElementById("delete_order")
      );
      myModal.hide();

      $("body").removeClass("modal-open");
      $(".fade").removeClass("show");
      $("body").css("padding-right", "0px");

      setTimeout(() => {
        this.loader = false;
      }, 1000);
    },
  },
  created() {
    this.getPayments();
     setTimeout(() => {
        this.loader = false;
      }, 1000);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/accounts/my-wallets.vue